export function safeStr(v) {
  if (v === null || v === undefined) return '';
  return String(v);
}

export function normalizeSlug(slug) {
  return safeStr(slug).toLowerCase();
}

export function getQuestionSlug(q) {
  return normalizeSlug(q?.type?.slug || q?.type);
}

export function isSelectableSlug(slug) {
  const normalized = normalizeSlug(slug);
  return normalized === 'unique' || normalized === 'multiple' || normalized === 'logic';
}

export function isDescriptiveSlug(slug) {
  const normalized = normalizeSlug(slug);
  return (
    normalized === 'descriptive' ||
    normalized === 'text' ||
    normalized === 'description' ||
    normalized === 'code_reader' ||
    normalized === 'code'
  );
}

export function isMediaSlug(slug) {
  const normalized = normalizeSlug(slug);
  return normalized === 'image' || normalized === 'video';
}

export function isPlateSlug(slug) {
  const normalized = normalizeSlug(slug);
  return (
    normalized === 'vehicle_plate' ||
    normalized === 'wagon_plate' ||
    normalized === 'implement_plate'
  );
}

export function hasBackAttachments(q) {
  return Array.isArray(q?.attachments) && q.attachments.length > 0;
}

export function hasLocalFiles(q) {
  const files = q?.attachment?.files;
  return !!files && files.length > 0;
}

export function isAnswered(q) {
  const slug = getQuestionSlug(q);

  if (!!q?.needAttachment && (hasBackAttachments(q) || hasLocalFiles(q))) {
    return true;
  }

  if (isSelectableSlug(slug)) {
    return (q.responses || []).some((r) => !!r.selected);
  }

  if (isPlateSlug(slug)) {
    const plate =
      safeStr(q?.questionDescriptiveResponse) ||
      safeStr(q?.vehicle?.plate) ||
      safeStr(q?.wagon?.plate);
    return plate.trim().length > 0;
  }

  if (isDescriptiveSlug(slug)) {
    const desc = safeStr(q.questionDescriptiveResponse).trim();
    return desc.length > 0;
  }

  if (isMediaSlug(slug)) {
    return !!q.sentAttachment || hasBackAttachments(q) || hasLocalFiles(q);
  }

  if (isPlateSlug(slug)) {
    if (q.vehicle || q.wagon) {
      return true;
    }
  }

  const desc = safeStr(q.questionDescriptiveResponse).trim();
  return (q.responses || []).some((r) => !!r.selected) || desc.length > 0;
}

export function isAttachmentRequiredByBackend(q) {
  const slug = getQuestionSlug(q);
  const required = !!q?.required;

  if (isMediaSlug(slug)) return required;
  if (q?.needAttachment) return required;

  return false;
}

export function shouldRenderUpload(q) {
  const slug = getQuestionSlug(q);
  return isMediaSlug(slug) || !!q?.needAttachment;
}
